module.exports = __webpack_public_path__ + "static/img/quan.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coaches/quan.jpg
// module id = j1RE
// module chunks = 0